import { worksheetActionTypes, feedbackTypes } from '../data/constants';

const initialState = {
  feedbackIndex: -1, // the item in the choice list that is displaying feedback
  feedbackType: feedbackTypes.NONE, // the nature of the feedback being displayed.
};

/**
 * keeps a note of the current type of feedback being displayed to the player
 */
const soundReducer = (state = initialState, action) => {
  switch (action.type) {
    case worksheetActionTypes.ON_CORRECT_START:
      return {
        ...state,
        feedbackIndex: action.payload.index,
        feedbackType: feedbackTypes.CORRECT,
      };
    case worksheetActionTypes.ON_INCORRECT_START:
      return {
        ...state,
        feedbackIndex: action.payload.index,
        feedbackType: feedbackTypes.INCORRECT,
      };
    case worksheetActionTypes.ON_CORRECT_END:
    case worksheetActionTypes.ON_INCORRECT_END:
    case worksheetActionTypes.INIT_WORKSHEET:
    case 'SELECT_ACTIVITY':
      return {
        ...state,
        feedbackType: feedbackTypes.NONE,
      };
    default:
      return state;
  }
};

export default soundReducer;
